/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { File_ } from './File_';
import { ResourceKind } from './ResourceKind';

export const ResourceFile: core.serialization.ObjectSchema<serializers.ResourceFile.Raw, Truvity.ResourceFile> =
    core.serialization.object({
        annotations: core.serialization.record(core.serialization.string(), core.serialization.string()),
        createdAt: core.serialization.property('created_at', core.serialization.date()),
        data: File_,
        deletedAt: core.serialization.property('deleted_at', core.serialization.date().optional()),
        etag: core.serialization.string(),
        id: core.serialization.string(),
        kind: ResourceKind,
        labels: core.serialization.record(core.serialization.string(), core.serialization.string()),
        modifiedAt: core.serialization.property('modified_at', core.serialization.date()),
        revision: core.serialization.number(),
    });

export declare namespace ResourceFile {
    export interface Raw {
        annotations: Record<string, string>;
        created_at: string;
        data: File_.Raw;
        deleted_at?: string | null;
        etag: string;
        id: string;
        kind: ResourceKind.Raw;
        labels: Record<string, string>;
        modified_at: string;
        revision: number;
    }
}
